export default __webpack_public_path__ + "static/media/Scholar's Wristbands of the Eternal Eclipse.4856618c.jpg";